
/* eslint-disable-next-line */
(function ($) {
    $(document).ready(function () {

        $('#shop-mega-menu').click(function(){
            $('#mega-menu-components').addClass('show');
            $('.main-menu-container').addClass('hide');
            $('.mobile-menu-wrap > .back-btn-wrap').addClass('hide');
            $('.secondary-menu-container').addClass('hide');
        })


        $('#mega-menu-components .single-menu:not(.page) .menu-link').each(function(){
            $(this).click(function(){
                var sub_id = $(this).parent().attr('id');

                console.log(sub_id);
                $('#sub-' + sub_id).addClass('show');
                $('#mega-menu-components').addClass('show-child');

            })

        })

        $('.one-deep').click(function(){
            $('#mega-menu-components').removeClass('show');
            $('.main-menu-container').removeClass('hide');
            $('.secondary-menu-container').removeClass('hide');
        })

        $('.two-deep').each(function(){
            $(this).click(function(e){
                e.preventDefault();
                $('#mega-menu-components').removeClass('show-child');
                $(this).parent().removeClass('show');

            })
        })

        $('.main-menu .menu-item .nav-link:not(#shop-mega-menu)').each(function(){
            $(this).click(function(){
                $('.mobile-menu-wrap > .back-btn-wrap').removeClass('hide');
            })
        })
        $('.mobile-menu-wrap > .back-btn-wrap .btn-back').click(function(){
            $(this).parent().addClass('hide');
        })



        $('.navbar-toggler.mobile-menu-toggle').click(function(){
            if(!$(this).hasClass('collapsed')){
                $('#mega-menu-components').removeClass('show');
                $('.main-menu-container').removeClass('hide');
                $('.mobile-menu-wrap > .back-btn-wrap').removeClass('hide');
                $('#mega-menu-components').removeClass('show-child');
                $('.secondary-menu-container').removeClass('hide');
            }
        })

    });


    /* eslint-disable-next-line */
})(jQuery);
